<span class="badge badge-success">
    <i class="fas fa-money-bill-wave"></i> Venda
</span>